import React from "react";
import { CheckCircle2, Clock } from "lucide-react";

/**
 * patient.status: true = Reported, false = Pending
 * Pending cases get stronger visual attention per spec.
 */
export default function StatusBadge({ status }) {
  if (status) {
    return (
      <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium bg-[#F0FDF4] text-[#15803D] border border-[#BBF7D0]">
        <CheckCircle2 className="w-3.5 h-3.5" />
        Reported
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold bg-[#FEF2F2] text-[#DC2626] border border-[#FCA5A5]">
      <Clock className="w-3.5 h-3.5" />
      Pending
    </span>
  );
}
